<!-- <router-outlet></router-outlet> -->
<div *ngIf="isLoading | async">
  <app-loader></app-loader>
</div>
<app-userlogin
  (EnableMenus)="onOpen($event)"
  *ngIf="loginVisible"
></app-userlogin>
<app-master *ngIf="visibility" (EnableMenus)="onOpen($event)"></app-master>
<!-- <div style="overflow: hidden;">
  <router-outlet></router-outlet>
</div> -->
